import { render, staticRenderFns } from "./DiamondsTable.vue?vue&type=template&id=af542c62"
import script from "./DiamondsTable.vue?vue&type=script&lang=js"
export * from "./DiamondsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports